import { css } from 'lit';

export default [
  css`
  `,
];
